declare const API_SERVER: string;
declare const SENTRY_ENVIRONMENT: string;
declare const SENTRY_TRACK_COMPONENTS: string;
declare const SENTRY_DSN: string;
declare const SENTRY_SAMPLE_RATE: string;

export const SERVER_API: string = API_SERVER;

// eslint-disable-next-line no-undef
// @ts-ignore

type TSentryConfig = {
  environment: string;
  trackComponents: boolean;
  dsn: string;
  tracesSampleRate: number;
};

export const SENTRY_OPTIONS: TSentryConfig = {
  environment: SENTRY_ENVIRONMENT,
  trackComponents: SENTRY_TRACK_COMPONENTS === 'true',
  dsn: SENTRY_DSN,
  tracesSampleRate: Number(SENTRY_SAMPLE_RATE),
};

export const genderList: Array<any> = [
  {
    label: 'Мужской',
    value: 'Male',
  },
  {
    label: 'Женский',
    value: 'Female',
  },
];

type mdvAddress = {
  BIRTH_PLACE: string;
  REGISTRATION_ADDRESS_CODE: string;
  RESIDENTIAL_ADDRESS_CODE: string;
  OTHER_ADDRESS_CODE: string;
};

export const statusApplication = {
  CREATED: {
    id: 1,
    name: 'Создано',
  },
  IN_WORK: {
    id: 2,
    name: 'Принято в работу',
  },
  CHECKED: {
    id: 3,
    name: 'Проверено',
  },
  SERVICE_PROVIDE: {
    id: 4,
    name: 'Услуга оказана',
  },
  DENIED: {
    id: 5,
    name: 'Отказано',
  },
  CANCEL: {
    id: 6,
    name: 'Отменено',
  },
  IN_PROCESS_CANCEL: {
    id: 7,
    name: 'В процессе отмены',
  },
};

export const sourceApplication = {
  INDIVIDUALLY: {
    id: 1,
    name: 'Лично',
  } as Catalogs.IGeneralRow,
  EPGU: {
    id: 2,
    name: 'ЕПГУ',
  } as Catalogs.IGeneralRow,
  MFC: {
    id: 3,
    name: 'МФЦ',
  } as Catalogs.IGeneralRow,
};

export const sourceApplicationList = Object.values(sourceApplication);

export const interdepartmenStatusRequest = {
  SUCCESS: 'success', // Ответ получен
  DANGER: 'danger', // При выполнении запроса произошла ошибка
  ATTENTION: 'attention', // Требуется участие оператора
  IN_PROCESS: 'in_process', // в процессе
  CONVICTED: 'local_police', //  Судим
  PASSPORT_PROBLEM: 'passport_problem', // Проблемы с паспортом
};

export const mvdAddressCodes: mdvAddress = {
  BIRTH_PLACE: '000',
  REGISTRATION_ADDRESS_CODE: '200',
  RESIDENTIAL_ADDRESS_CODE: '201',
  OTHER_ADDRESS_CODE: '202',
};

export const PassportCheckResult = {
  notFound: 'notFoundDoc',
  invalid: 'invalidDoc',
  valid: 'validDoc',
};

export const ROLES = {
  OPERATOR: 1,
  LOGGER: 2,
  ADMINISTRATOR: 3,
};

export const ROWS_PER_PAGE = 25;

export const ROWS_PER_PAGE_LIST: Array<number> = [25, 50, 100, 500];

export const colorsForWhiteText: Array<string> = [
  '#b71c1c',
  '#880E4F',
  '#4A148C',
  '#311B92',
  '#1A237E',
  '#0D47A1',
  '#01579B',
  '#006064',
  '#004D40',
  '#AB47BC',
  '#7E57C2',
  '#5C6BC0',
  '#1B5E20',
  '#33691E',
  '#827717',
  '#F57F17',
  '#FF6F00',
  '#E65100',
  '#3E2723',
  // '#212121',
  '#263238',
  '#c62828',
  '#AD1457',
  '#6A1B9A',
  '#42A5F5',
  '#29B6F6',
  '#26C6DA',
  '#26A69A',
  '#66BB6A',
  '#4527A0',
  // '#283593',
  '#1565C0',
  '#0277BD',
  '#00838F',
  '#00695C',
  '#2E7D32',
  '#558B2F',
];

export const weekdays = {
  1: 'Пн',
  2: 'Вт',
  3: 'Ср',
  4: 'Чт',
  5: 'Пт',
  6: 'Сб',
  7: 'Вс',
};

export enum DelegateInfo {
  applicant = 'applicant',
  representative = 'representative',
}

export enum GetResultsType {
  mfc = '1',
  department = '2',
}

/**
 *
 */
export enum Gender {
  male = '1',
  female = '2',
}

/**
 * Цели подачи заявления
 */
export enum Goal {
  permission = 1,
  permission_copy = 2,
  report = 3,
}

export const ApplicationReasons = {
  FirstTime: '1',
  Lost: '2',
};
export const AddressTypes = {
  Registration: '1',
  Residence: '2',
};

export enum UserBAckGroundTaskStatus {
  pending = 'pending',
  executing = 'executing',
  error = 'error',
  finished = 'finished',
}

export enum LimitingResourcesQueueSource {
  tisIntegration = 'tis_integration',
  systemApplication = 'system_application',
  manual = 'manual',
}

export enum LimitingResourcesQueueStatus {
  pending = 'pending',
  notificationSent = 'notification_sent',
  permissionGranted = 'permission_granted',
  excluded = 'excluded',
}

export enum LimitingResourcesApplicationSource {
  tisIntegration = 'tis_integration',
  systemApplication = 'system_application',
}

export enum LimitingResourcesApplicationStatus {
  created = 'created',
  approved = 'approved',
  rejected = 'rejected',
}

export enum LimitingResourcesRejectApplicationType {
  transit = 'transit',
  reject = 'reject',
}
